"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Filtr_1 = require("../../../../components/Filtr/Filtr");
var hooks_1 = require("../../../../hooks");
var BlockPrestupky = function (_a) {
    var _b;
    var value = _a.value, handleChange = _a.handleChange, name = _a.name;
    var _c = hooks_1.useCiselnik('typyPrestupku'), data = _c.data, loading = _c.loading, error = _c.error;
    if (loading) {
        return react_1.default.createElement("div", null, "loading");
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var typ = (_b = data === null || data === void 0 ? void 0 : data.find(function (d) { return d.id === (value === null || value === void 0 ? void 0 : value.Typ); })) === null || _b === void 0 ? void 0 : _b.nazev;
    var DatumOd = new Date((value === null || value === void 0 ? void 0 : value.Od) || '');
    var DatumDo = new Date((value === null || value === void 0 ? void 0 : value.Do) || '');
    if (handleChange && name) {
        handleChange(name, typ);
    }
    return (react_1.default.createElement("div", null,
        "P\u0159estupky:",
        react_1.default.createElement("br", null),
        typ && react_1.default.createElement(Filtr_1.Filtr, null, typ),
        (value === null || value === void 0 ? void 0 : value.Od) && react_1.default.createElement(Filtr_1.Filtr, null,
            "Od: ", DatumOd.getDate() + "." + (DatumOd.getMonth() + 1) + "." + DatumOd.getFullYear()),
        (value === null || value === void 0 ? void 0 : value.Do) && react_1.default.createElement(Filtr_1.Filtr, null,
            "Do: ", DatumDo.getDate() + "." + (DatumDo.getMonth() + 1) + "." + DatumDo.getFullYear()),
        ((value === null || value === void 0 ? void 0 : value.PokutaOd) || (value === null || value === void 0 ? void 0 : value.PokutaOd) === 0) && react_1.default.createElement(Filtr_1.Filtr, null,
            "Pokuta od: ", value === null || value === void 0 ? void 0 :
            value.PokutaOd.toLocaleString(),
            " K\u010D"),
        ((value === null || value === void 0 ? void 0 : value.PokutaDo) || (value === null || value === void 0 ? void 0 : value.PokutaDo) === 0) && react_1.default.createElement(Filtr_1.Filtr, null,
            "Pokuta do: ", value === null || value === void 0 ? void 0 :
            value.PokutaDo.toLocaleString(),
            " K\u010D")));
};
exports.default = BlockPrestupky;
